import styled from 'styled-components';

import InputOption from '~molecules/InputOption';
import SideItemInputHeight from '~molecules/SideItemInputHeight';

export const BacksplashOption = styled(InputOption)(({ theme }) => ({
  paddingInlineStart: '22rem',
  paddingBlockStart: '20rem',

  color: theme.palette.darkJungleGreen,
  fontSize: theme.typography.size14,
}));

export const SideItemHeight = styled(SideItemInputHeight)({
  marginInlineStart: '55rem',
});
